import { getIntlLocaleFromCulture } from "~~/server/utils/mapping/localeMapping";
import { formatDateLocale } from "~~/shared/utils/formatting";

export function formatCurrency(value: number | undefined | null): string {
  const { locale } = useI18n();
  return formatCurrencyLocale(locale.value, value);
}

export function formatDateFromString(value?: string | null, options?: Intl.DateTimeFormatOptions): string {
  if (!value) {
    return "";
  }

  try {
    const date = new Date(value);
    return formatDate(date, options);
  }
  catch (e) {
    console.error("Error parsing date", e);
    return value;
  }
}

export function formatDate(value: Date, options?: Intl.DateTimeFormatOptions): string {
  const { locale } = useI18n();
  const adjustedLocale = getIntlLocaleFromCulture(locale.value);
  return formatDateLocale(value, adjustedLocale, options);
}
